// User role constants - values match API roles directly
// API returns: ROLE_ADMIN, ROLE_PROVIDER, ROLE_STAFF, ROLE_CUSTOMER
export const USER_ROLE = {
	SUPER_ADMIN: 'ROLE_ADMIN',
	SALON_OWNER: 'ROLE_PROVIDER',
	STAFF: 'ROLE_STAFF',
} as const;

// Roles that are not allowed to access the business portal
export const UNSUPPORTED_API_ROLES = ['ROLE_CUSTOMER'] as const;

// UserRole type derived from the constant
export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export interface User {
	id?: string;
	email?: string;
	name: string;
	image?: string;
	role: UserRole;
	businessName?: string;
	locationId?: string;
	passwordChangeRequired?: boolean;
	phoneVerified?: boolean;
}

export interface LoginResult {
	success: boolean;
	error?: string;
	passwordChangeRequired?: boolean;
	role?: UserRole;
}

export interface AuthState {
	user: User | null;
	token: string | null;
	isAuthenticated: boolean;
	isInitialized: boolean;
	// eslint-disable-next-line no-unused-vars
	login: (email: string, password: string, rememberMe?: boolean) => Promise<LoginResult>;
	logout: () => void;
	// eslint-disable-next-line no-unused-vars
	updateUser: (user: Partial<User>) => void;
	initializeAuth: () => void;
	checkSessionExpiration: () => boolean;
	// eslint-disable-next-line no-unused-vars
	refreshSession: (token: string, userData: Partial<User>) => void;
}

export interface LoginCredentials {
	email: string;
	password: string;
	rememberMe?: boolean;
}
